interface SEOSchemaProps {
  type: 'Organization' | 'WebSite' | 'WebPage' | 'Article' | 'FAQPage';
  data?: Record<string, unknown>;
}

export default function SEOSchema({ type, data = {} }: SEOSchemaProps) {
  const schemas: Record<string, Record<string, unknown>> = {
    Organization: {
      '@context': 'https://schema.org',
      '@type': 'Organization',
      name: '韩漫漫画网站',
      url: 'https://www.hanmancomic.com',
      description: '韩漫漫画网站致力于提供完整韩漫大全、优质推荐和流行排行榜，您可免费下拉式阅读高清内容，无广告干扰，享受纯粹阅读乐趣。',
      contactPoint: {
        '@type': 'ContactPoint',
        email: 'contact@hanmancomic.com',
        contactType: 'customer service',
        availableLanguage: ['Chinese'],
      },
      ...data,
    },
    WebSite: {
      '@context': 'https://schema.org',
      '@type': 'WebSite',
      name: '韩漫漫画网站',
      url: 'https://www.hanmancomic.com',
      description: '韩漫漫画网站致力于提供完整韩漫大全、优质推荐和流行排行榜，您可免费下拉式阅读高清内容，无广告干扰，享受纯粹阅读乐趣。',
      inLanguage: 'zh-CN',
      potentialAction: {
        '@type': 'SearchAction',
        'target': {
          '@type': 'EntryPoint',
          urlTemplate: 'https://www.hanmancomic.com/search?q={search_term_string}',
        },
        'query-input': 'required name=search_term_string',
      },
      ...data,
    },
    WebPage: {
      '@context': 'https://schema.org',
      '@type': 'WebPage',
      ...data,
    },
    Article: {
      '@context': 'https://schema.org',
      '@type': 'Article',
      ...data,
    },
    FAQPage: {
      '@context': 'https://schema.org',
      '@type': 'FAQPage',
      ...data,
    },
  };

  const schema = schemas[type];
  if (!schema) return null;

  return <script type="application/ld+json">{JSON.stringify(schema)}</script>;
}